import script from "./BrandFormDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./BrandFormDialog.vue?vue&type=script&setup=true&lang=js"

import "./BrandFormDialog.vue?vue&type=style&index=0&id=d089a586&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d089a586"]])

export default __exports__